import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SvgComponent } from '@components/svg.component';
import { CourseModel } from '@models/course/course.model';
import { FormatPricePipe } from '@pipes/format-price.pipe';

@Component({
  selector: 'app-summary-course-card',
  standalone: true,
  imports: [TranslateModule, SvgComponent, FormatPricePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './summary-course-card.component.html',
})
export class SummaryCourseCardComponent {
  course = input.required<CourseModel>();
  serviceName = input.required<string>();
  showPrice = input.required<boolean>();
  disabled = input<boolean>(false);
  showRemoveButton = input<boolean>(true);
  quantity = input<number>(1);
  bgColor = input<string | null>(null);
  imageUrl = input<string | null>(null);

  remove = output<void>();
}
